import axios from "axios";

import ConvertObjectParamToString from "@/commons/ConvertObjectParamToString";
const deleteWarnDoc = "/api/telcoServices/deleteWarnDoc";
const baseApiFile = "/api/revenue/telcoServices/file?file_id=";

export default class aclatedKSService {
  private convertObjectParamToStrings: ConvertObjectParamToString = ConvertObjectParamToString.instance;
  // public getAllCompanies(): Promise<any> {
  //   return new Promise<any>((resolve, reject) => {
  //     axios
  //       .get("/api/business/companies-DesHis")
  //       .then((res) => {
  //         resolve(res.data);
  //       })
  //       .catch((err) => {
  //         reject(err);
  //       });
  //   });
  // }
  public getAllCompanies(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get("/api/business/companies-DesHis")
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public SearchDebtCCDV(querySearch?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post("/api/business/ks-fee-debt/luy-ke", querySearch)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  public excelCCDV(querySearch?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post("/api/business/ks-fee-debt/luy-ke/excel", querySearch, { responseType: "blob" })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          console.log(reject(err));
        });
    });
  }

  public getNetwork(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get("/api/business/cert/network-type")
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
}
